import dayjs from "dayjs";


export const differentDays = ({ date = dayjs(), numberOfDays }) => {
  // Subtract income number of days from current date
  const startDate = date.subtract(numberOfDays, "day");
    return startDate
};
